import Big from "big.js";
import { division } from "../../../../lib/common";
import { makeOneNumberScore } from "./func";
import { PurchaseIntentBig } from "./types";

/**
 * 購入意向の計算処理
 */
export class PurchaseIntentAggregator {
	constructor() {}
	protected top = new Big(0);
	protected second = new Big(0);
	protected total = new Big(0);
	public countUp(purchaseIntent: number, weight: number) {
		this.total = this.total.add(weight);
		if (purchaseIntent === 1) this.top = this.top.add(weight);
		if (purchaseIntent === 2) this.second = this.second.add(weight);
	}
	public topBox() {
		const sampleSize = this.total;
		return division(this.top, sampleSize);
	}
	public secondBox() {
		const sampleSize = this.total;
		return division(this.second, sampleSize);
	}
	public top2Box() {
		const sampleSize = this.total;
		return division(this.top.add(this.second), sampleSize);
	}
	public getResult(): PurchaseIntentBig {
		const sampleSize = this.total;
		const topBox = this.topBox();
		const secondBox = this.secondBox();
		const top2Box = this.top2Box();
		console.log({ sampleSize: sampleSize.toNumber(), topBox: topBox.toNumber(), secondBox: secondBox.toNumber() });
		const score = makeOneNumberScore(topBox, secondBox);
		return { sampleSize, score, top2Box, topBox, secondBox };
	}
}
